import { ArticlePublisher } from '@/cmsComponents/ArticlePublisher';
import CmsImage from '@/cmsComponents/CmsImage';
import { IArticleSummary } from '@/types/cms';
import cx from 'classnames';
import { PATH } from 'constants/path';
import Link from 'next/link';
import React from 'react';

import { defaultAlt } from 'components/Image';

import styles from './ArticleItemCover.module.scss';

export enum ImageShape {
  Small = 'small',
  Large = 'large',
}

interface ArticleItemCoverProps {
  article: IArticleSummary;
  imgShape?: ImageShape;
}

const ArticleItemCover = ({ article, imgShape = ImageShape.Large }: ArticleItemCoverProps) => {
  return (
    <div className={cx(styles.container, styles[imgShape])}>
      {article.cover && (
        <CmsImage
          priority
          imageProps={article.cover}
          altText={article.cover.alternativeText ?? defaultAlt}
          format="medium"
          layout="fill"
          objectFit="cover"
        />
      )}
      <div className={styles.bgColor}>
        <Link
          prefetch={false}
          href={`${PATH.ARTICLES}/${article.slug}`}
          as={`${PATH.ARTICLES}/${article?.slug}`}
          className={styles.link}
        >
          <div className={styles.cover}>
            {article.article_category?.name && (
              <div className={styles.category}>{article.article_category?.name}</div>
            )}
            <div className={styles.title}>
              <h1>{article.title}</h1>
            </div>
            <ArticlePublisher
              author={article?.author}
              publishedDate={article?.published_date}
              fontColor="white"
            />
          </div>
        </Link>
      </div>
    </div>
  );
};

export default ArticleItemCover;
